(ns app.front.ui.text-button)

(defn text-button
  "Makes a button that looks like a text link."
  [opts & children]
  (into [:button.bx--link.p-0.border-0.bg-transparent.text-sm.text-ui-blue-100.rounded-none
         (merge {:type :button} opts)]
        children))

(defn text-button-2
  "Makes a button that looks like a text link with less forced CSS classes"
  [opts & children]
  (into [:button.bg-transparent.border-0.p-0.text-ui-blue.hover:underline
         opts]
        children))
